/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PasskeyLoginOptionsForm { 
    /**
     * Handle opaco dell\'utente: il user_id Base64URL emesso da /register/options
     */
    user_handle: string;
}

